// 확장 : 이름, 프로필 이미지
// 참고 : https://supabase.com/docs/guides/auth/managing-user-data

//
// {
//   "instance_id": "00000000-0000-0000-0000-000000000000",
//   "id": "475efd1c-c68f-4a78-b84d-9be8d79d1ff4",
//   "aud": "authenticated",
//   "role": "authenticated",
//   "email": "ajs0904@naver.com",
//   "encrypted_password": "$2a$10$BM9.oy1qGc5zNSC9I2l6X.PqpfrbP/xvMkmHpIFtAk3OtE0wAF91S",
//   "email_confirmed_at": "2025-09-01 02:06:18.92822+00",
//   "invited_at": null,
//   "confirmation_token": "",
//   "confirmation_sent_at": "2025-09-01 02:06:08.538718+00",
//   "recovery_token": "",
//   "recovery_sent_at": null,
//   "email_change_token_new": "",
//   "email_change": "",
//   "email_change_sent_at": null,
//   "last_sign_in_at": "2025-09-01 07:28:23.259938+00",
//   "raw_app_meta_data": {
//     "provider": "email",
//     "providers": [
//       "email"
//     ]
//   },
//   "raw_user_meta_data": {
//     "sub": "475efd1c-c68f-4a78-b84d-9be8d79d1ff4",
//     "email": "ajs0904@naver.com",
//     "email_verified": true,
//     "phone_verified": false
//   },
//   "is_super_admin": null,
//   "created_at": "2025-09-01 02:06:08.49138+00",
//   "updated_at": "2025-09-02 01:44:22.938206+00",
//   "phone": null,
//   "phone_confirmed_at": null,
//   "phone_change": "",
//   "phone_change_token": "",
//   "phone_change_sent_at": null,
//   "confirmed_at": "2025-09-01 02:06:18.92822+00",
//   "email_change_token_current": "",
//   "email_change_confirm_status": 0,
//   "banned_until": null,
//   "reauthentication_token": "",
//   "reauthentication_sent_at": null,
//   "is_sso_user": false,
//   "deleted_at": null,
//   "is_anonymous": false,
//   "providers": [
//     "email"
//   ]
// }

export type User = {
  id: string;
  created_at: string;
  updated_at: string | null;
  login_at: string | null;

  state: string; // active, inactive
  role: string; // admin, user
  provider: string; // email, google, apple
  email: string;
  phone: string;
  name: string;
  timestamp: string | null;
  cover_id: string | null;
};
